<template>
<div class="form-group">
  <p>Add Option</p>
  <form @submit.prevent="onSubmit" v-model="options">
    <label for="option_name">{{ optionNameLabel }}</label>
    <input id="option_name"type="text" class="form-control" name="option_name" v-model="options.option_name"/>
    <label for="option_type">{{ optionTypeLabel }}</label>
    <select id="option_type" type="text" class="form-control" name="option_type" v-model="options.option_type">
      <option value="" disabled="disabled">--Select One--</option>
      <option value="relation">Relation</option>
      <option value="relationship">Relationship</option>
    </select>
    <label for="option_active">{{ optionActiveLabel }}</label>
    <input id="option_active" type="checkbox" class="checkbox-primary" name="option_active" v-model="options.option_active"/>
    <button name="submit" type="submit" class="btn btn-default pull-right">Add Option</button>
  </form>
</div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      options: {
        option_name: '',
        option_type: '',
        option_active: true
      },
      optionNameLabel: 'Name(eg I am an Officer, a Family Member)',
      optionTypeLabel: 'Relationship Type(eg relation, relationship)',
      optionActiveLabel: 'Active'
    }
  },
  methods: {
    onSubmit() {

      return axios.post('ffba/store',this.options)
          .then(response => {
              console.log(response.data);
          })
    }
  }
}
</script>